/** PURE_IMPORTS_START ._ErrorObservable PURE_IMPORTS_END */
import { ErrorObservable } from './ErrorObservable';
export var _throw = ErrorObservable.create;
//# sourceMappingURL=throw.js.map



//////////////////
// WEBPACK FOOTER
// ./node_modules/rxjs/_esm5/observable/throw.js
// module id = ./node_modules/rxjs/_esm5/observable/throw.js
// module chunks = vendor